module.exports = __webpack_public_path__ + "media/assets/EllipseGreen-c7a1db89202234a7d152702355c5f6c5.svg";